import { Outlet } from 'react-router-dom'

import CollectionsBootstrap from 'modules/finance/lib/AccountingCollectionsBootstrap'

const AccountingRootPage = () => {
  return (
    <CollectionsBootstrap>
      <Outlet />
    </CollectionsBootstrap>
  )
}

export default AccountingRootPage
